import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { selexpConParApiDuck } from './api-ducks/selexp-conpar-api-duck';
import { selexpPerformanceApiDuck } from './api-ducks/selexp-performance-api-duck';
import { selexpEarningsApiDuck } from './api-ducks/selexp-earnings-api-duck';
import { selexpNotifiApiDuck } from './api-ducks/selexp-notifi-api-duck';
import { graphApiDuck } from './api-ducks/graph-duck/api-duck-graph';
import impersonationDuckReducer from './impersonation/duck-impersonation';
import appConfigDuckReducer from './app-config/duck-app-config';
import participationDetailsDuckReducer from './participation-details/duck-participation-details';
import downloadManagerReducer from './download-panel/download-panel';
import filtersDuckReducer from './filters/duck-filters';
import featureFlagsReducer from './feature-flags/duck-feature-flags';
import { selexpComplianceApiDuck } from './api-ducks/selexp-compliance-api-duck';
import bannerMessagesDuckReducer from './banner-messages/duck-banner-messages';
import { setupListeners } from '@reduxjs/toolkit/query';

// Create the root reducer separately so we can extract the RootState type
const rootReducer = combineReducers({
  impersonation: impersonationDuckReducer,
  appConfig: appConfigDuckReducer,
  participationDetails: participationDetailsDuckReducer,
  downloadManager: downloadManagerReducer,
  filters: filtersDuckReducer,
  featureFlags: featureFlagsReducer,
  bannerMessages: bannerMessagesDuckReducer,
  [selexpConParApiDuck.reducerPath]: selexpConParApiDuck.reducer,
  [selexpPerformanceApiDuck.reducerPath]: selexpPerformanceApiDuck.reducer,
  [selexpEarningsApiDuck.reducerPath]: selexpEarningsApiDuck.reducer,
  [selexpComplianceApiDuck.reducerPath]: selexpComplianceApiDuck.reducer,
  [selexpNotifiApiDuck.reducerPath]: selexpNotifiApiDuck.reducer,
  [graphApiDuck.reducerPath]: graphApiDuck.reducer,
});

// Wrap the configure store into a function to be able to generate a stor with a preloaded State. (For tests purposes)
export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(selexpConParApiDuck.middleware)
        .concat(selexpPerformanceApiDuck.middleware)
        .concat(selexpEarningsApiDuck.middleware)
        .concat(selexpComplianceApiDuck.middleware)
        .concat(selexpNotifiApiDuck.middleware)
        .concat(graphApiDuck.middleware),
    preloadedState,
  });

export const store = setupStore();

// Enable refetch behaviors
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
